/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:24
 * @LastEditTime : 2023-06-16 09:10:45
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\table.js
 */
import request from "@/utils/request";

export function post(url, data) {
  return request({
    url: url,
    method: "post",
    data,
    timeout:180000,
  });
}
export function get(url, params) {
  return request({
    url: url,
    method: "get",
    params,
  });
}
